import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";

export default {
  namespaced: true,
  state: {
    userOtpInfo: {},
    verifyOtpInfo: {}
  },
  mutations: {
    setUserOtp(state, payload) {
      state.userOtpInfo = payload.response;
    },
    setVerifyDeletedUser(state, payload) {
      console.log(payload.response, "payload.response");
      state.verifyOtpInfo = payload.response;
    }
  },
  getters: {
    getUserOTPStatus: (state) => {
      return state.userOtpInfo
    },
    getVerifyDeletedUser: (state) => {
      return state.verifyOtpInfo
    }
  },
  actions: {
    generateDeleteUserOTP({ commit, rootGetters, state }, payload) {
      const headers = Headers();
      ApiCalls.GENERATE_DELETE_USER_OTP({
        headers: {
          ...headers,
          mobile: payload.mobile
        },
        payload: payload,
      })
        .then(function (response) {
          if (response?.data) {
            commit("setUserOtp", {
              "response": response?.data,
            });
          }
        })
        .catch(function (error) {
          console.log("error");
        })
        .finally(function () {
          console.log("user otp executed");
        })
    },
    verifyDeleteUserAccount({ commit, rootGetters, state }, payload) {
      const headers = Headers();
      ApiCalls.CONFIRM_USER_DELETED({
        headers: {
          ...headers,
          mobile: payload.mobile
        },
        payload: payload,
      })
        .then(function (response) {
          if (response?.data) {
            commit("setVerifyDeletedUser", {
              "response": response?.data,
            });
          }
        })
        .catch(function (error) {
          console.log("error", error);
        })
        .finally(function () {
          console.log("verify user otp");
        })

    }
  }
};
